import { useState, type MouseEvent, type ReactNode } from 'react';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import {
  Box,
  Button,
  IconButton,
  Menu,
  MenuItem,
  Typography,
} from '@mui/material';
import ListItemIcon from '@mui/material/ListItemIcon';

export interface ActionsMenuProps {
  actions: {
    label: string;
    onClick: () => void;
    Icon?: ReactNode;
  }[];
  collapsed?: boolean;
}

export const ActionsMenu = ({ actions, collapsed }: ActionsMenuProps) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const open = Boolean(anchorEl);
  const handleClick = (event: MouseEvent<HTMLElement>) =>
    setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);

  return (
    <Box className="media-print-remove">
      <IconButton
        sx={{ display: collapsed ? 'block' : { md: 'none' } }}
        onClick={handleClick}
      >
        <MoreVertIcon />
      </IconButton>
      <Button
        endIcon={open ? <ExpandLessIcon /> : <ExpandMoreIcon />}
        onClick={handleClick}
        sx={{ display: collapsed ? 'none' : { xs: 'none', md: 'inline-flex' } }}
      >
        Opções
      </Button>
      <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
        {actions.map(({ onClick, label, Icon }) => (
          <MenuItem key={label} onClick={onClick}>
            {Icon && <ListItemIcon>{Icon}</ListItemIcon>}
            <Typography>{label}</Typography>
          </MenuItem>
        ))}
      </Menu>
    </Box>
  );
};
